import LazyLoad from "vanilla-lazyload";
import Menu from "./js/Menu";
import History from "./js/History";
import Popups from "./js/Popups";
import Langs from "./js/Langs";
import Videos from "./js/Videos";
import TextImg from "./js/TextImg";
import Tab from "./js/Tab";
import Accordion from "./js/Accordion";
import ContactForm from "./js/ContactForm";
import SearchForm from "./js/SearchForm";
import FramesAnimation from "./js/FramesAnimation";
import StoresMap from "./js/StoresMap";
import Advisors from "./js/Advisors";
import Jobs from "./js/Jobs";
import "./scss/main.scss";

document.addEventListener("DOMContentLoaded", () => {
  new Menu();
  new Langs();
  new SearchForm('.search-form');
  const frames = document.querySelectorAll('.frames');
  if (frames){
    frames.forEach(el => {
      new FramesAnimation(el);
    });
  }

  const storeMaps = document.querySelectorAll('.stores-map');
  if (storeMaps){
    storeMaps.forEach(el => {
      new StoresMap(el);
    });
  }

  const textImgs = document.querySelectorAll('.text-img');
  if (textImgs){
    textImgs.forEach(el => {
      new TextImg(el);
    });
  }

  const advisors = document.querySelectorAll('.advisors');
  if (advisors){
    advisors.forEach(el => {
      new Advisors(el);
    });
  }

  const jobs = document.querySelectorAll('.jobs');
  if (jobs){
    jobs.forEach(el => {
      new Jobs(el);
    });
  }

  const contactForms = document.querySelectorAll('.wpcf7');
  if (contactForms){
    contactForms.forEach(el => {
      new ContactForm(el);
    });
  }

  const tabs = document.querySelectorAll('.tabs');
  if (tabs){
    tabs.forEach(el => {
      new Tab(el);
    });
  }

  new Popups();
  new Videos();
  new Accordion();
  new History();
});

function recalcFontSize() {
    const renderedWidth = window.innerWidth;
    const screenWidth = screen.width;
    if (renderedWidth > 1920) {
      // obliczamy px: szerokość * 0.009
      const sizePx = (screenWidth * 0.009);
      document.documentElement.style.fontSize = `${sizePx}px`;
    } else {
      // usuwamy inline‐owe nadpisanie, wraca CSS z arkusza
      document.documentElement.style.fontSize = '';
    }
}

// wywołaj na starcie
document.addEventListener('DOMContentLoaded', recalcFontSize);
// i przy każdej zmianie rozmiaru okna
window.addEventListener('resize', recalcFontSize);